import React from "react";
import useRevealOnScroll from "../../../hooks/useRevealOnScroll";
import { FaShippingFast, FaMoneyBillWave, FaUndoAlt } from "react-icons/fa";

const Feature = ({ icon, title, desc }) => (
  <div className="flex flex-col items-center text-center p-4">
    <div className="bg-yellow-700 rounded-full p-3 mb-3 text-white">
      {icon}
    </div>
    <h4 className="font-semibold text-blue-800 mb-1">{title}</h4>
    <p className="text-sm md:text-base text-blue-50 leading-relaxed">{desc}</p>
  </div>
);

const FeaturesNewsletter = () => {
  const { ref, revealed } = useRevealOnScroll(0.12);

  return (
    <section
      ref={ref}
      className={`mt-8 py-12 bg-gradient-to-r bg-yellow-100 from-blue-800 to-blue-700 transition-transform duration-700 ease-out transform opacity-0 ${
        revealed ? "opacity-100 translate-y-0" : "translate-y-6"
      }`}
    >
      <div className="max-w-6xl mx-auto px-4">
        <h2 className="text-center text-blue-800 text-2xl font-bold mb-6">Pourquoi acheter chez JamaalStore ?</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
          <Feature
            icon={<FaShippingFast className="w-7 h-7" />}
            title="Livraison rapide"
            desc="Suivi en temps réel du processus et livraison express dans les meilleurs délais."
          />
          <Feature
            icon={<FaMoneyBillWave className="w-7 h-7" />}
            title="Paiement à la livraison"
            desc="Payez en toute sécurité lorsque vous recevez votre commande."
          />
          <Feature
            icon={<FaUndoAlt className="w-7 h-7" />}
            title="Remboursement possible"
            desc="Sous condition. Contactez notre service client pour plus de détails."
          />
        </div>

        <div className="bg-blue-800 rounded-lg p-6 md:p-8 flex flex-col md:flex-row items-center justify-between">
          <div className="mb-4 md:mb-0">
            <h3 className="text-white text-xl font-semibold">Newsletter</h3>
            <p className="text-white">Recevez nos offres et nouveautés directement par email.</p>
          </div>

          <form className="flex w-full md:w-auto space-x-3">
            <input
              type="email"
              placeholder="Votre email"
              className="px-4 py-2 rounded-md bg-white text-gray-800 focus:outline-none"
            />
            <button className="bg-yellow-700 hover:bg-yellow-700 text-gray-900 px-4 py-2 rounded-md font-semibold">S'inscrire</button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default FeaturesNewsletter;
